import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { Col, Row, Badge } from 'reactstrap'
import { Divider, Empty, message, Popconfirm, Table, Tooltip } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBuilding, faEdit, faSearch, faToggleOff, faToggleOn, faTrash } from '@fortawesome/free-solid-svg-icons'
import moment from 'moment'

import EditFaqModal from './EditFaqModal'
import DepartmentsAttachedModal from '../../Departments/DepartmentsAttachedModal'

import Pagination from '../../../components/Pagination'

import { deleteFaq, toggleDepartment, toggleOnAllDepartments, updateFaq } from '../services'
import { handleError } from '../../../helpers'

export default function FaqsTable({ faqs, reload, pagination, setPagination }) {
	const [editModal, setEditModal] = useState(null)
	const [departmentsModal, setDepartmentsModal] = useState(null)
	
	const columns = [
		{
			title: 'Pregunta',
			dataIndex: 'question',
			render: (t,r) => <Link to={`/faqs/${r.id}`}>{t}</Link>
		},
		{
			title: 'Respuesta',
			dataIndex: 'answer',
		},
		{
			title: 'Estado',
			dataIndex: 'disabled_at',
			render: t => t ? <Badge color='danger'>Oculto</Badge> : <Badge color="success">Visible</Badge>,
		},
		{
			title: 'Aperturas',
			dataIndex: 'opens_count',
			render: t => `${t} en total`
		},
		{
			title: 'Acciones',
			width: 230,
			render: (t,r) => (
				<React.Fragment>
					<Tooltip title="Ver">
						<Link to={`/faqs/${r.id}`}>
							<FontAwesomeIcon 
								className="text-link" 
								icon={faSearch}
							/>{" "}
							<span className='text-link'>Ver</span>	
						</Link>
					</Tooltip>
					<Divider type='vertical' />
					<Tooltip title="Departamentos Asociados" onClick={()=>setDepartmentsModal(r)}>
						<FontAwesomeIcon 
							className="text-link" 
							icon={faBuilding}
						/>{" "}
						<span className='text-link'>Depart.</span>
					</Tooltip>
					<Divider type='vertical' />
					<Tooltip title={r.disabled_at ? 'Habilitar' : 'Ocultar'} onClick={()=>handleToggle(r)}>
						<FontAwesomeIcon 
							className="text-link" 
							icon={r.disabled_at ? faToggleOff : faToggleOn}
						/>{" "}
						<span className='text-link'>{r.disabled_at ? 'Habilitar' : 'Ocultar'}</span>
					</Tooltip>
					<br />
					<Tooltip title="Editar" onClick={()=>setEditModal(r)} >
						<FontAwesomeIcon 
							className="text-link" 
							icon={faEdit}
						/>{" "}
						<span className='text-link'>Editar</span>
					</Tooltip>
					<Divider type='vertical' />
					<Tooltip title="Eliminar">
						<Popconfirm
							title="Esta acción no puede ser revertida"
							okText="Eliminar"
							cancelText="Cancelar"
							onConfirm={() => handleDelete(r.id)}
							okButtonProps={{ danger:true }}
						>
							<FontAwesomeIcon className="text-link" icon={faTrash} />{" "}
							<span className='text-link'>Eliminar</span>
						</Popconfirm>
					</Tooltip>
				</React.Fragment>
			)
		}
	]

	const handleDelete = id => {
		deleteFaq(id)
			.then(res => {
				message.success(res.data.message)
				reload()
			})
			.catch(error => handleError(error))
	}

	const handleToggle = faq => {
		updateFaq(faq.id, { disabled_at: faq.disabled_at ? null : moment().format('YYYY-MM-DD HH:mm:ss') })
			.then(res => {
				message.success(res.data.message)
				reload()
			})
			.catch(error => handleError(error))
	}

	const handleToggleDepartment = departmentId => {
		toggleDepartment({ 
			faq_id: departmentsModal.id, 
			department_id: departmentId 
		})
			.then(res => {
				message.success(res.data.message)
				reload()
			})
			.catch(error => handleError(error))
	}

	const handleToggleOnAllDepartments = () => {
		toggleOnAllDepartments({ 
			faq_id: departmentsModal.id, 
		})
			.then(res => {
				message.success(res.data.message)
				reload()
				setDepartmentsModal(null)
			})
			.catch(error => handleError(error))
	}

	const expandedRowRender = r => (
		<React.Fragment>
			<Row>
				<Col>
					<p className='mb-2'>
						<strong>Categorias: </strong>
						{r.categories.length > 0 ? r.categories.map(c => `${c.name} | `) : <em className='hint-text'>Sin categorías</em>}
					</p>
				</Col>
			</Row>
			<p className='mb-2'><strong>Palabras Clave: </strong>{r.keywords}</p>
		</React.Fragment>
	)
	
	return (
		<React.Fragment>
			<Table 
				dataSource={faqs}
				rowKey={r => r.id}
				pagination={false}
				columns={columns}
				size="small"
				expandable={{ expandedRowRender }}
				locale={{ emptyText: (
					<Empty
						description="No se encontraron registros" 
						imageStyle={{ height: '80px' }}
					/> 
				)}}
			/>
			<Pagination 
				pagination={pagination}
				updatePagination={setPagination}
				reload={reload}
			/>
			{ editModal && (
				<EditFaqModal 
					visible
					onClose={() => setEditModal(null)}
					reload={() => {
						reload()
						setEditModal(null)
					}}
					faq={editModal}
				/>
			)}
			{ departmentsModal && (
				<DepartmentsAttachedModal 
					visible
					onClose={() => setDepartmentsModal(null)}
					departmentsAttached={departmentsModal.departments}
					onToggle={departmentId => handleToggleDepartment(departmentId)}
					onToggleOnAll={handleToggleOnAllDepartments}
				/>
			)}
		</React.Fragment>
	)
}